import { ISanityItemOption } from '@rbi-ctg/menu';
import { IImage } from 'generated/sanity-graphql';

export interface IAddExtrasContentItemProps {
  index: number;
  itemName: string;
  onChange(index: number): void;
  itemPrice: number;
  itemImage?: IImage;
  itemOption?: ISanityItemOption;
  subtitle?: string;
  itemCalories?: string;
  max?: number;
  isInCart?: boolean;
  maxAmount?: number;
}

export enum AddExtraItemControlType {
  NUMBER_INPUT,
  CHECKBOX,
}
